export default __webpack_public_path__ + "static/media/8.db071716.svg";